import React from 'react';
import '../styles.css';
import { connect } from 'react-redux';
import { Background } from './Background';
import { FADE, MAX_LEADERS, GREEN, RED, CYAN } from '../../HOME/const';
import * as f from '../logic';
import LeaderItem from '../../HOME/COMPONENTS/LeaderItem';
import { TM_BACKGROUND } from '../const';
import { setUserId, showLeaderboards } from '../../HOME/REDUX/actions';
import LeaderBase from '../../HOME/COMPONENTS/LeaderBase';
import BackButton from './BackButton';
import HomeButton from '../../HOME/COMPONENTS/HomeButton';
import { getDate, scrollClass } from '../../HOME/utils';
import _ from 'lodash';

class Leaderboard extends LeaderBase {
  state = {
    ...this.state,
    size: this.props.size,
    score: this.props.stats ? this.props.stats.grade : 0,
  };

  componentDidMount() {
    this.init(this.handleSelection);
  }

  getQuery = () => {
    const { size } = this.state;

    return this.leaders
      .where('size', '==', size)
      .orderBy('score', 'desc')
      .orderBy('plays', 'desc')
      .limit(MAX_LEADERS);
  };

  cacheKey(size) {
    size = size || this.state.size;

    return `${this.props.app} LEADERS • ${size}`;
  }

  userKey(id, size) {
    id = id || this.props.uid;
    size = size || this.state.size;

    return `${size} • ${id}`;
  }

  handleSelection = size => {
    size = size || this.state.size;

    this.setState({ size }, () => {
      this.getCachedLeaders(true);

      f.getStats(this.props, stats => {
        const { plays, bestScore } = stats;
        this.setState({ score: bestScore || 0, plays }, this.updateRanks);
      });
    });
  };

  dataToSubmit = () => {
    const { size, score, plays } = this.state;
    return { size, name: this.state.name.trim(), score, plays, date: getDate() };
  };

  renderNavigation = () => (
    <>
      <BackButton />
      <HomeButton />
    </>
  );

  render() {
    const background = TM_BACKGROUND;
    const rankColor = this.state.size === 5 ? GREEN : this.state.size === 6 ? CYAN : RED;
    const submitColor = this.state.size === 5 ? 'rgb(0, 155, 0)' : this.state.size === 6 ? 'rgb(0, 155, 155)' : 'rgb(155, 0, 0)';
    const scoreAlias = 'Best';

    return (
      <>
        <div className={`leaders-screen ${this.props.showLeaders === FADE ? 'fadeout' : ''}`}>
          {this.renderClickableScreen()}
          <div className="leaders fadein-fast" style={{ background, backgroundImage: Background, color: 'white' }}>
            <div className="leaders-selector" style={{ grid: 'auto/1fr auto 10px auto 10px auto 1fr' }}>
              {_.map([5, 6, 7], (size, i) => {
                const col = `1/${i * 2 + 2}`;
                const current = size === this.state.size;
                const cls = `leaders-circle tt-leaders-size-selector leaders-selector-item ${current ? 'leaders-selector-item-current' : ''}`;
                const background = size === 5 ? GREEN : size === 6 ? CYAN : RED;

                return (
                  <div
                    key={col}
                    className={cls}
                    style={{ gridArea: col, width: '60px', height: '46px', background }}
                    onClick={() => this.handleSelection(size)}>
                    {`${size}×${size}`}
                  </div>
                );
              })}
            </div>
            <div className={scrollClass} style={{ gridArea: '2/1', display: 'initial' }}>
              {_.map(this.state.users, (u, i) => (
                <LeaderItem key={i} rank={i + 1} data={u.data} rankColor={rankColor} scoreAlias={scoreAlias} />
              ))}
            </div>
            {this.renderCommon(rankColor, submitColor, scoreAlias)}
          </div>
        </div>
      </>
    );
  }
}

function mapStateToProps({ tm, common }) {
  return { ...tm, ...common };
}

export default connect(
  mapStateToProps,
  { setUserId, showLeaderboards }
)(Leaderboard);
